// ── V150: 레시피 복사 — 원래 레시피를 그대로 복사해서 조금만 고쳐 새 버전으로 ─────────
// 사장님: "염지제 원래 레시피를 복사 누르고 '염지제 ver1'을 조금만 수정하면 사용할 수 있게.
//          새로운 버전을 만들기 수월하도록"
//   · 이름은 '염지제 ver1' (이미 있으면 ver2, ver3 …). 'ver1'을 복사해도 '염지제 ver2'
//   · 같은 원본에서 나온 레시피끼리는 copiedFrom.id(맨 처음 원본)로 묶인다 → 레시피 화면의 '버전' 줄

const VER = /\s*ver\.?\s*(\d+)\s*$/i;
const squish = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();

/** 이름 끝의 'ver N'을 뗀 이름 */
export const baseName = (name) => {
  const raw = String(name || '').trim();
  return raw.replace(VER, '').trim() || raw;
};

/**
 * 다음 버전 이름. existingNames: 레시피·단가표 이름 전부 (같은 이름이 생기지 않게)
 * @returns {{ name, name_zh, n }}
 */
export function nextVersionName(name, existingNames = [], nameZh = '') {
  const base = baseName(name);
  const used = new Set((existingNames || []).map(squish));
  let max = 0;
  for (const n of existingNames || []) {
    const s = String(n || '').trim();
    const m = s.match(VER);
    if (m && squish(s.replace(VER, '')) === squish(base)) max = Math.max(max, Number(m[1]) || 0);
  }
  let k = max + 1;
  while (used.has(squish(`${base} ver${k}`))) k++;
  const zb = baseName(nameZh);
  return { name: `${base} ver${k}`, name_zh: String(nameZh || '').trim() ? `${zb} ver${k}` : '', n: k };
}

/** 이 레시피가 속한 버전 묶음의 맨 처음 원본 id */
export const familyRootId = (r) => (r && r.copiedFrom && r.copiedFrom.id) || (r && r.id) || '';

/**
 * 복사본 초안 (아직 저장 전 — id는 저장할 때 새로 생긴다)
 * @param {object} src  복사할 레시피
 * @param {Array} allRecipes 모든 레시피
 * @param {Array} prices 단가표 (반제품 줄 이름과 겹치지 않게)
 */
export function makeRecipeCopy(src, allRecipes = [], prices = []) {
  if (!src) return null;
  const names = [...(allRecipes || []).map(r => r && r.name), ...(prices || []).map(p => p && p.name)].filter(Boolean);
  const { name, name_zh } = nextVersionName(src.name, names, src.name_zh);
  const rootId = familyRootId(src);
  const root = (allRecipes || []).find(r => r && r.id === rootId);
  return {
    name,
    name_zh,
    type: src.type || 'semi',
    total_output: src.total_output || '',
    serving_g: src.serving_g || '',
    note: src.note || '',
    note_zh: src.note_zh || '',
    selling_price: src.selling_price || '',
    ingredients: (src.ingredients || []).map(i => ({ ...i })),
    copiedFrom: { id: rootId, name: (root && root.name) || (src.copiedFrom && src.copiedFrom.name) || src.name || '' },
  };
}

/** 같은 이름(띄어쓰기·대소문자 무시)의 레시피가 이미 있는지 (자기 자신 제외) */
export function hasSameName(name, allRecipes = [], exceptId = '') {
  const k = squish(name);
  return !!k && (allRecipes || []).some(r => r && r.id !== exceptId && squish(r.name) === k);
}

/**
 * 복사본을 카테고리 목록의 어디에 넣을지 — 같은 묶음(원본·이전 버전) 바로 다음.
 * 묶음이 이 카테고리에 없으면 맨 끝.
 */
export function insertIndexForCopy(items = [], rootId = '') {
  let at = -1;
  (items || []).forEach((r, i) => { if (r && rootId && familyRootId(r) === rootId) at = i; });
  return at >= 0 ? at + 1 : (items || []).length;
}
